// SEETRUE — product page: filmstrip scroll, packaging horizontal scroll,
// variant swatches (frame + lens) synced across hero & buy bar, AJAX add-to-cart, sticky buy bar.

(function () {
  'use strict';
  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var data = {};
  var dataEl = root.querySelector('[data-product-json]');
  try { data = JSON.parse(dataEl.textContent); } catch (e) { data = {}; }
  var variants = data.variants || [];
  var frameIndex = data.frameIndex;
  var lensIndex = data.lensIndex;

  var priceEls = root.querySelectorAll('[data-price]');
  var idInput = root.querySelector('[data-variant-id]');
  var filmImgs = root.querySelectorAll('.pdp-img img');
  var addButtons = root.querySelectorAll('[data-add]');
  var orderButtons = root.querySelectorAll('[data-order]');
  var barThumb = root.querySelector('[data-bar-thumb]');

  var state = { frame: null, lens: null };

  function initFromSwatches() {
    var f = root.querySelector('[data-frame].is-active');
    var l = root.querySelector('[data-lens].is-active');
    state.frame = f ? f.getAttribute('data-value') : null;
    state.lens = l ? l.getAttribute('data-value') : null;
  }

  function currentVariant() {
    return variants.find(function (v) {
      var okF = frameIndex == null || v.options[frameIndex] === state.frame;
      var okL = lensIndex == null || lensIndex < 0 || v.options[lensIndex] === state.lens;
      return okF && okL;
    });
  }

  function setGallery(v) {
    if (!filmImgs.length) return;
    var imgs = (data.media || []).slice();
    if (v && v.image) imgs[0] = v.image;
    filmImgs.forEach(function (img, i) { if (imgs[i]) img.src = imgs[i]; });
    if (barThumb && imgs[0]) barThumb.src = imgs[0];
  }

  function update() {
    var v = currentVariant();
    var available = v && v.available;
    if (v) {
      priceEls.forEach(function (el) { el.textContent = v.price; });
      if (idInput) idInput.value = v.id;
      setGallery(v);
    }
    addButtons.forEach(function (b) {
      b.disabled = !available;
      if (b.hasAttribute('data-add-label')) b.textContent = available ? b.getAttribute('data-add-label') : (window.variantStrings ? window.variantStrings.soldOut : 'sold out');
    });
    orderButtons.forEach(function (b) { b.disabled = !available; });
  }

  function syncActive(group, value) {
    root.querySelectorAll('[data-' + group + ']').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-value') === value);
    });
  }

  root.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-frame],[data-lens]');
    if (!sw) return;
    var group = sw.hasAttribute('data-frame') ? 'frame' : 'lens';
    var value = sw.getAttribute('data-value');
    state[group] = value;
    syncActive(group, value);
    update();
  });

  /* ---------- add to cart (AJAX → Dawn cart drawer) ---------- */
  function addToCart(then) {
    var v = currentVariant();
    if (!v || !v.available || !window.routes) return;
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCartCount();
        var drawer = document.querySelector('cart-drawer');
        if (then === 'checkout') { window.location = '/checkout'; return; }
        if (drawer && drawer.open) drawer.open();
        else if (window.routes) window.location = window.routes.cart_url;
      });
  }
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var el = document.querySelector('[data-cart-count]');
      if (el) { el.textContent = c.item_count; el.classList.toggle('hidden', c.item_count === 0); }
    });
  }
  addButtons.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); addToCart('drawer'); }); });
  orderButtons.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); addToCart('checkout'); }); });

  initFromSwatches();
  update();

  /* ---------- gallery: desktop = lerp-smoothed filmstrip scroll; mobile = native swipe carousel + dots ---------- */
  var hero = root.querySelector('.pdp-hero');
  var stack = root.querySelector('.pdp-img-stack');
  if (hero && stack) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mqMobile = window.matchMedia('(max-width: 900px)');
    var target = 0, current = 0, rafId = null;

    function filmTarget() {
      var rect = hero.getBoundingClientRect();
      var total = hero.offsetHeight - window.innerHeight;
      var progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      target = -66.666 * progress;
    }
    function filmTick() {
      current += (target - current) * (reduceMotion ? 1 : 0.085);
      if (Math.abs(target - current) < 0.01) current = target;
      stack.style.transform = 'translateY(' + current + '%)';
      rafId = Math.abs(target - current) > 0.001 ? requestAnimationFrame(filmTick) : null;
    }
    function filmScroll() {
      if (mqMobile.matches) return;
      filmTarget();
      if (!rafId) rafId = requestAnimationFrame(filmTick);
    }
    function applyMode() {
      if (mqMobile.matches) {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        current = target = 0;
        stack.style.transform = '';
      } else {
        filmTarget();
        current = target;
        stack.style.transform = 'translateY(' + current + '%)';
      }
    }
    window.addEventListener('scroll', filmScroll, { passive: true });
    window.addEventListener('resize', applyMode);
    applyMode();

    /* mobile carousel dots */
    var dotsWrap = root.querySelector('.pdp-dots');
    if (dotsWrap) {
      var dots = dotsWrap.querySelectorAll('.pdp-dot');
      var dotRaf = null;
      var syncDots = function () {
        var active = stack.clientWidth ? Math.round(stack.scrollLeft / stack.clientWidth) : 0;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
        dotRaf = null;
      };
      stack.addEventListener('scroll', function () {
        if (!dotRaf) dotRaf = requestAnimationFrame(syncDots);
      }, { passive: true });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          glideTo(parseInt(dot.getAttribute('data-dot'), 10));
        });
      });
    }

    /* smooth eased glide to slide index (snap disabled during, re-enabled after) */
    var snapRaf = null;
    function glideTo(index) {
      var w = stack.clientWidth || 1;
      var last = stack.children.length - 1;
      index = Math.max(0, Math.min(last, index));
      if (snapRaf) cancelAnimationFrame(snapRaf);
      stack.classList.add('is-dragging');
      var startL = stack.scrollLeft, dist = index * w - startL, t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / 420);
        stack.scrollLeft = startL + dist * (1 - Math.pow(1 - p, 3));
        if (p < 1) { snapRaf = requestAnimationFrame(step); }
        else { snapRaf = null; stack.classList.remove('is-dragging'); }
      }
      snapRaf = requestAnimationFrame(step);
    }

    /* mobile: mouse drag-to-scroll with eased snap on release (touch scrolls natively) */
    var down = false, dragged = false, startX = 0, startLeft = 0, startIndex = 0;
    var lastX = 0, lastT = 0, vX = 0;
    stack.addEventListener('pointerdown', function (e) {
      if (!mqMobile.matches || e.pointerType !== 'mouse') return;
      if (snapRaf) { cancelAnimationFrame(snapRaf); snapRaf = null; }
      down = true; dragged = false;
      startX = e.clientX; startLeft = stack.scrollLeft;
      startIndex = stack.clientWidth ? Math.round(startLeft / stack.clientWidth) : 0;
      lastX = startX; lastT = Date.now(); vX = 0;
    });
    stack.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) > 4) {
        dragged = true;
        stack.classList.add('is-dragging');
        try { stack.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (dragged) {
        stack.scrollLeft = startLeft - dx;
        var now = Date.now(), dt = now - lastT;
        if (dt > 0) vX = (e.clientX - lastX) / dt;
        lastX = e.clientX; lastT = now;
      }
    });
    function endDrag() {
      if (!down) return;
      down = false;
      if (!dragged) return;
      var w = stack.clientWidth || 1, dxTotal = lastX - startX, target = startIndex;
      if (dxTotal < -w * 0.12 || vX < -0.35) target = startIndex + 1;
      else if (dxTotal > w * 0.12 || vX > 0.35) target = startIndex - 1;
      glideTo(target);
    }
    stack.addEventListener('pointerup', endDrag);
    stack.addEventListener('pointercancel', endDrag);
    stack.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- sticky buy bar visibility (self-contained: after hero, before footer) ---------- */
  var bar = root.querySelector('.pdp-buy-bar');
  var heroEl = root.querySelector('.pdp-hero');
  var footer = document.querySelector('.footer');
  if (bar && heroEl) {
    var updateBar = function () {
      var pastHero = heroEl.getBoundingClientRect().bottom < window.innerHeight * 0.5;
      var footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      bar.classList.toggle('is-visible', pastHero && !footerVisible);
    };
    window.addEventListener('scroll', updateBar, { passive: true });
    updateBar();
  }
})();
